import axios from 'axios'

const annieConfig = require('../config/myannieawards')

export default axios.create({
  baseURL: annieConfig.API_URL,
  timeout: 0
  // headers: {
  //   'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
  //   'Content-Type': 'application/json'
  // }
})



// WEBPACK FOOTER //
// ./src/API.js